
 $(document).ready(function(){       
   var scroll_start = 0;
   var startchange = $('.nav-change');
   var offset = startchange.offset();
   $(document).scroll(function() { 
      scroll_start = $(this).scrollTop();
      if(scroll_start > offset.top) {
          $('.nav-change').css('background-color', '#222');
       } else {
          $('.nav-change').css('background-color', 'transparent');
       }
   });
});
  